import ApiService from '@/services/api.service';

const state = {
  isLoading: false,
  incominggoods: {
    data: [],
    meta: {
      page: {},
    },
  },
  incominggood: {},
};

const getters = {
  getLoading: (state) => {
    return state.isLoading;
  },
  getIncomingGoods: (state) => {
    return state.incominggoods;
  },
  getIncomingGood: (state) => {
    return state.incominggood;
  },
  getError: (state) => {
    return state.error;
  },
};

const mutations = {
  setLoader: (state, status) => (state.isLoading = status),
  setIncomingGoods: (state, data) => (state.incominggoods = data),
  setIncomingGood: (state, data) => (state.incominggood = data),
  setError: (state, data) => (state.error = data),
};

const actions = {
  async fetchIncomingGoods({ commit }, { pageNumber, pageSize, search }) {
    commit('setLoader', true);
    const params = {};
    let page = [];
    let filter = [];
    if (pageNumber && pageNumber !== '') page['number'] = pageNumber;
    if (pageSize) page['size'] = pageSize;
    if (search && search !== '') filter['search'] = search;

    Object.keys(page).map((item) => {
      const key = `page[${item}]`;
      Object.assign(params, { [key]: page[item] });
    });
    Object.keys(filter).map((item) => {
      const key = `filter[${item}]`;
      Object.assign(params, { [key]: filter[item] });
    });
    Object.assign(params, { include: 'office,order,purchase-order' });
    Object.assign(params, { sort: '-createdAt' });
    try {
      let response = await ApiService.get('/api/v1/incoming-goods', {
        params,
      });
      commit('setIncomingGoods', response.data);
      commit('setLoader', true);
      commit('setError', null);
      return response;
    } catch (error) {
      commit('setError', error.response.data.errors);
      commit('setIncomingGoods', {
        data: [],
        meta: {
          page: {},
        },
      });
    }
    commit('setLoader', false);
  },
  async createIncomingGood({ commit }, payload) {
    commit('setLoader', true);
    try {
      let response = await ApiService.post('/api/v1/incoming-goods', payload);
      commit('setIncomingGood', response.data);
      commit('setLoader', true);
      commit('setError', null);
      return response;
    } catch (error) {
      commit('setError', error.response.data.errors);
      commit('setIncomingGood', {});
    }
    commit('setLoader', false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
